// extracted by mini-css-extract-plugin
export default {"graph":"evolution-viewer_graph__NlVaq","drawing":"evolution-viewer_drawing__QJ-4I"};